module.exports = __webpack_public_path__ + "static/media/port_icon.be09fa1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/port_icon.png
// module id = 505
// module chunks = 0